import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FileService } from '#file/fileService';

import { PostKey } from './keys';

export function useDeletePostFile(id?: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => FileService.deleteFile(id).then((response) => response.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [PostKey.POSTS, id] });
    },
  });
}
